import React, { useEffect } from "react";

const DeepLink = () => {
  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);

    const id = queryParams.get("id");
    const startDate = queryParams.get("startDate");
    const endDate = queryParams.get("endDate");
    const image = queryParams.get("image");
    const vouchertoken = queryParams.get("vouchertoken");
    const voucherType = queryParams.get("voucherType");

  
    // Construct the custom deep link
    const deepLink = `giftr://open?id=${id}&startDate=${startDate}&endDate=${endDate}&image=${encodeURIComponent(
      image
    )}&vouchertoken=${vouchertoken}&voucherType=${voucherType}`;

    // const androidDeeplinkUrl = `giftr://open?id=${id}&startDate=${startDate}&endDate=${endDate}&image=${encodeURIComponent(
    //   image
    // )}&vouchertoken=${vouchertoken}&voucherType=${voucherType}`;

    // Platform-based fallback URLs
    const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);
    const isAndroid = /Android/i.test(navigator.userAgent);

    const fallbackUrl = isIOS
      ? "https://apps.apple.com/in/app/giftr/id6746745500" // Replace with your iOS App Store link
      : isAndroid
      ? "https://play.google.com/store/apps/details?id=com.wm.giftr&pcampaignid=web_share" // Replace with your Android package
      : alert("No application found"); // Optional fallback for desktop


    window.location.href = deepLink;

    // After 2 seconds, if app isn't installed, fallback
    const timer = setTimeout(() => {
      window.location.href = fallbackUrl;
      
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div style={{ textAlign: "center", padding: "2rem" }}>
      Redirecting to the app...
    </div>
  );
};

export default DeepLink;
